import React from 'react'
import Button from 'components/Button'
import UploadResultIcon from 'components/icons/UploadResultIcon'
import {
  UploadMsgFlex,
  ResultIconDiv,
  ResultDiv,
  ButtonDiv,
  FileInfoDiv,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/Components/ConfirmReleaseOffer/style'

const AddConfirm = ({ onClose, resultText ='Result Updated Successfully', resultDescription = 'File has been successfully updated with active candidates.' }) => {
  return (
    <UploadMsgFlex column center centerVertically>
      <ResultIconDiv>
        <UploadResultIcon />
      </ResultIconDiv>
      {resultText && <ResultDiv>{resultText}</ResultDiv>}
      {resultDescription &&   <FileInfoDiv>
          {resultDescription}
        </FileInfoDiv>
      }
    
      <ButtonDiv>
        <Button.Secondary
          text="Close"
          width="80px"
          height="36px"
          onClick={onClose}
        />
      </ButtonDiv>
    </UploadMsgFlex>
  )
}

export default AddConfirm
